import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { DialogService } from '../../services/core/dialog-service';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard  {
    constructor(public dialogService: DialogService) {
    }
    canDeactivate(component: CanComponentDeactivate) {
        //return component.canDeactivate ? component.canDeactivate() ? this.dialogService.confirm('Discard changes?') : false : true;
        return component.canDeactivate() ? true : this.dialogService.confirm('Discard changes?');
    }
}